export const icerikler = {
  title: 'İçerikler',
  titleEN: 'Contents',
  description: 'Markanın hedef kitlesine göre liste ve quiz formatında hazırlanan, kullanıcıya olumlu bir Onedio içeriği tecrübesi yaşatırken bir yandan native olarak marka ile tüketiciyi buluşturan içerik modelidir.',
  descriptionEN: 'Content model designed in a list and quiz format according to the brand\'s target audience, providing users with a positive Onedio experience while natively connecting the brand with the consumer.',
  tabs: [
    {
      id: 1,
      title: 'Orijinal İçerikler',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Sürdürülebilir İçerik Stratejisi',
          image: 'https://srv-cdn.onedio.com/store/d84225a8b56827bb5057ef62f92389ce1878f9487a2ce2f353b5eef648afa9af.png',
          url: 'https://vimeo.com/502607216/622b5c1e7e',
          category: 'Kategori'
        },
        {
          id: 2,
          name: 'Datalı Content Çalışması',
          image: 'https://srv-cdn.onedio.com/store/e97c6f79d7bf6db24bd895fb4b955dfb113fa1e0e560f5865234bae1d3892dc9.png',
          url: 'https://proj-assets.onedio.com/rtdu/index.html',
          category: 'Rtdu'
        }
      ]
    },
    {
      id: 2,
      title: 'Liste İçeriği',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Sponsorlu Liste Örneği',
          image: 'https://srv-cdn.onedio.com/store/cfd15cca1e9fefc4eeb2dbeef3d606802d2e2ecde6ca976bcf1ab41158deb471.png',
          url: 'https://onedio.com/haber/1-milyon-ile-ilgili-ufkunuzu-bir-kat-daha-genisletecek-11-enteresan-bilgi-839353',
          category: 'Liste'
        },
        {
          id: 2,
          name: 'Content & Sosyal Medya Paketi',
          image: 'https://srv-cdn.onedio.com/store/3a62acaee7ffd78303a17f4599ac2b7f82ced8f26409ce0594261495a8fbb00a.png',
          url: 'https://proj-assets.onedio.com/smrp-final/index.html',
          category: 'Smrp'
        }
      ]
    },
    {
      id: 3,
      title: 'Quiz / Test İçeriği',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: 'Sponsorlu Quiz Örneği',
          image: 'https://srv-cdn.onedio.com/store/93dbed07fbebd8db03a2adb63582e241dd22ccd64d89d87a6709d1a0f92dbf19.png',
          url: 'https://onedio.com/haber/ask-dolu-bir-yil-icin-sevgiline-yilbasinda-ne-hediye-almalisin-799496',
          category: 'Quiz'
        }
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Original Contents',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Sustainable Content Strategy',
          image: 'https://srv-cdn.onedio.com/store/d84225a8b56827bb5057ef62f92389ce1878f9487a2ce2f353b5eef648afa9af.png',
          url: 'https://vimeo.com/502607216/622b5c1e7e',
          category: 'Category'
        },
        {
          id: 2,
          name: 'Data-Driven Content Study',
          image: 'https://srv-cdn.onedio.com/store/e97c6f79d7bf6db24bd895fb4b955dfb113fa1e0e560f5865234bae1d3892dc9.png',
          url: 'https://proj-assets.onedio.com/rtdu/index.html',
          category: 'Rtdu'
        }
      ]
    },
    {
      id: 2,
      title: 'Lists',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Sponsored List Example',
          image: 'https://srv-cdn.onedio.com/store/cfd15cca1e9fefc4eeb2dbeef3d606802d2e2ecde6ca976bcf1ab41158deb471.png',
          url: 'https://onedio.com/haber/1-milyon-ile-ilgili-ufkunuzu-bir-kat-daha-genisletecek-11-enteresan-bilgi-839353',
          category: 'List'
        },
        {
          id: 2,
          name: 'Content & Social Media Package',
          image: 'https://srv-cdn.onedio.com/store/3a62acaee7ffd78303a17f4599ac2b7f82ced8f26409ce0594261495a8fbb00a.png',
          url: 'https://proj-assets.onedio.com/smrp-final/index.html',
          category: 'Smrp'
        }
      ]
    },
    {
      id: 3,
      title: 'Quizzes',
      sliderPerView: 1,
      width: '480px',
      slides: [
        {
          id: 1,
          name: 'Sponsored Quiz Example',
          image: 'https://srv-cdn.onedio.com/store/93dbed07fbebd8db03a2adb63582e241dd22ccd64d89d87a6709d1a0f92dbf19.png',
          url: 'https://onedio.com/haber/ask-dolu-bir-yil-icin-sevgiline-yilbasinda-ne-hediye-almalisin-799496',
          category: 'Quiz'
        }
      ]
    }
  ],
}

